import { CustomNavigationItemType } from 'types/graphql';

export type CustomNavigationItemTypeOption = {
  description: string;
  key: CustomNavigationItemType;
  title: string;
};

export const MENU_ITEM_DRAG_TYPE = 'navigation-item';

export const MAX_SECTION_DEPTH = 2;

export const customNavigationItemTypes: CustomNavigationItemTypeOption[] = [
  {
    description: 'Link to an external URL.',
    key: CustomNavigationItemType.link,
    title: 'Link',
  },
  {
    description: 'Connect a collection.',
    key: CustomNavigationItemType.collection,
    title: 'Collection',
  },
  {
    description: 'Connect a category.',
    key: CustomNavigationItemType.category,
    title: 'Category',
  },
  {
    description: 'Connect a brand page.',
    key: CustomNavigationItemType.brand,
    title: 'Brand',
  },
  {
    description: 'Create a subnavigation section.',
    key: CustomNavigationItemType.section,
    title: 'Section',
  },
];

export function getItemTypeLabel(type: CustomNavigationItemType): string {
  const option = customNavigationItemTypes.find((opt) => opt.key === type);
  return option?.title ?? type;
}
